module.exports = __webpack_public_path__ + "static/docker-2e644d3979c9eeb37dfb3e17416d40b5.png";